import React, { useEffect, useMemo } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import L from "leaflet";

// Icono VISITA
const createVisitaIcon = (color, number, resaltado = false) => {
  const size = resaltado ? 42 : 28;
  const fontSize = resaltado ? 15 : 12;
  const border = resaltado ? "4px solid #FFD700" : "3px solid white";
  const shadow = resaltado
    ? "0 0 0 4px rgba(255,215,0,0.5), 0 3px 10px rgba(0,0,0,0.5)"
    : "0 2px 5px rgba(0,0,0,0.3)";

  return L.divIcon({
    className: "custom-marker visita-marker",
    html: `<div style="
      background-color: ${color};
      color: white;
      width: ${size}px;
      height: ${size}px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      font-size: ${fontSize}px;
      border: ${border};
      box-shadow: ${shadow};
    ">${number}</div>`,
    iconSize: [size, size],
    iconAnchor: [size / 2, size / 2],
    popupAnchor: [0, -(size / 2)],
  });
};

// Icono CLIENTE
const createClienteIcon = (tienePedido, number, resaltado = false) => {
  const bgColor = tienePedido ? "#4CAF50" : "#FF5722";
  const iconEmoji = tienePedido ? "🛒" : "🏠";
  const border = resaltado ? "3px solid #FFD700" : "2px solid white";
  const shadow = resaltado
    ? "0 0 0 4px rgba(255,215,0,0.5), 0 4px 12px rgba(0,0,0,0.5)"
    : "0 3px 8px rgba(0,0,0,0.4)";
  const width = resaltado ? 44 : 36;
  const height = resaltado ? 50 : 42;

  return L.divIcon({
    className: "custom-marker cliente-marker",
    html: `<div style="
      background-color: ${bgColor};
      color: white;
      width: ${width}px;
      height: ${height}px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      padding-top: 2px;
      font-weight: bold;
      font-size: 10px;
      border: ${border};
      border-radius: 8px;
      box-shadow: ${shadow};
      position: relative;
    ">
      <span style="font-size: ${resaltado ? 14 : 12}px; font-weight: bold; line-height: 1;">${number}</span>
      <span style="font-size: ${resaltado ? 17 : 14}px; line-height: 1;">${iconEmoji}</span>
      <div style="
        position: absolute;
        bottom: -10px;
        left: 50%;
        transform: translateX(-50%);
        width: 0;
        height: 0;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-top: 10px solid ${bgColor};
      "></div>
    </div>`,
    iconSize: [width, height + 10],
    iconAnchor: [width / 2, height + 10],
    popupAnchor: [0, -(height + 10)],
  });
};

// Ajustar vista
const AjustarVista = ({ puntos }) => {
  const map = useMap();

  useEffect(() => {
    if (puntos.length === 1) {
      map.setView(puntos[0], 15);
    } else if (puntos.length > 1) {
      const bounds = L.latLngBounds(puntos);
      map.fitBounds(bounds, {
        padding: [50, 50],
        maxZoom: 17
      });
    }
  }, [puntos, map]);

  return null;
};

// COMPONENTE
const VisitaMapa = ({
  latVisita,
  lonVisita,
  latCliente,
  lonCliente,
  tienePedido = 0,
}) => {

  const visitorIcon = useMemo(
    () => createVisitaIcon("#1976d2", 1),
    []
  );

  const clientIcon = useMemo(
    () => createClienteIcon(tienePedido, 1),
    [tienePedido]
  );

  const puntos = [];

  if (latVisita && lonVisita) puntos.push([latVisita, lonVisita]);
  if (latCliente && lonCliente) puntos.push([latCliente, lonCliente]);

  const center = puntos.length ? puntos[0] : [0, 0];

  return (
    <div style={{
      width: "100%",
      maxWidth: "800px",
      height: "400px",
      margin: "20px auto",
      borderRadius: "10px",
      overflow: "hidden",
      border: "2px solid #ccc",
    }}>
      <MapContainer
        center={center}
        zoom={13}
        scrollWheelZoom={true}
        maxZoom={19}
        style={{ height: "100%", width: "100%" }}
      >
        <TileLayer
          attribution='&copy; OpenStreetMap'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          maxZoom={19}
        />

        <AjustarVista puntos={puntos} />

        {latVisita && lonVisita && (
          <Marker position={[latVisita, lonVisita]} icon={visitorIcon}>
            <Popup>Ubicación del Preventista</Popup>
          </Marker>
        )}

        {latCliente && lonCliente && (
          <Marker position={[latCliente, lonCliente]} icon={clientIcon}>
            <Popup>Ubicación del Cliente</Popup>
          </Marker>
        )}
      </MapContainer>
    </div>
  );
};

export default VisitaMapa;